import { render, staticRenderFns } from "./ProductCategoryEdit.vue?vue&type=template&id=5840a6b2&scoped=true&"
import script from "./ProductCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryEdit.vue?vue&type=style&index=0&id=5840a6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840a6b2",
  null
  
)

export default component.exports